import { FlowConsumerContextEnergy as FlowContext } from '../../context';
import { EnergyType } from '../../shared/types';

export const shouldSkipWhenOnlyWarmth = (context: FlowContext): boolean => {
  const { energyType } = context;

  return (
    energyType === EnergyType.Warmth ||
    energyType === EnergyType.WarmthAndTapWater ||
    energyType === EnergyType.WarmthAndCooling ||
    energyType === EnergyType.WarmthAndTapWaterAndCooling ||
    energyType === EnergyType.TapWater
  );
};
